import { useNavigate } from "react-router-dom"
import styled from "styled-components"

const Unauthorized = () => {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <Container>
            <Icon>&#128274;</Icon>
            <Title>Unauthorized</Title>
            <Subtitle>You do not have access to the requested page.</Subtitle>
            <BackButton onClick={goBack}>Go Back</BackButton>
        </Container>
    )
}

export default Unauthorized

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    height: 100dvh;
    padding: 2rem;
    background: #f8f9fb;
`

const Icon = styled.span`
    font-size: 6rem;
    margin-bottom: 1.5rem;
`

const Title = styled.h1`
    font-size: 3rem;
    font-weight: 800;
    color: #1e1e2d;
    margin-bottom: 0.5rem;
`

const Subtitle = styled.p`
    font-size: 1.5rem;
    color: #71717a;
    margin-bottom: 2rem;
    text-align: center;
`

const BackButton = styled.button`
    background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 1.2rem 3rem;
    font-size: 1.5rem;
    font-weight: 600;
    cursor: pointer;
    font-family: 'Nunito Sans', sans-serif;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(247, 112, 125, 0.3);
    }
`
